const INITIAL_STATE = {
  sponsors: [],
  loading: false,
  error: null,
  creating: false,
  editing: false,
  delete: false,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case 'GET_SPONSOR_REQUEST':
      return {
        ...state,
        loading: true,
      };
    case 'GET_SPONSOR_SUCCESS':
      return {
        ...state,
        loading: false,
        sponsors: action.payload,
      };
    case 'GET_SPONSOR_FAILURE':
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case 'CREATE_SPONSOR_REQUEST':
      return {
        ...state,
        creating: true,
      };
    case 'CREATE_SPONSOR_SUCCESS':
      return {
        ...state,
        creating: false,
        sponsors: [
          ...state.sponsors,
          action.payload,
        ],
      };
    case 'CREATE_SPONSOR_FAILURE':
      return {
        ...state,
        creating: false,
        error: action.payload,
      };
    case 'EDIT_SPONSOR_REQUEST':
      return {
        ...state,
        editing: true,
      };
    case 'EDIT_SPONSOR_SUCCESS':
      return {
        ...state,
        editing: false,
        sponsors: state.sponsors.map(c => (c._id === action.payload._id
          ? { ...c, ...action.payload }
          : c)
        ),
      };
    case 'EDIT_SPONSOR_FAILURE':
      return {
        ...state,
        editing: false,
        error: action.payload,
      };
    case 'DELETE_SPONSOR_REQUEST':
      return {
        ...state,
        deleting: true,
      };
    case 'DELETE_SPONSOR_SUCCESS':
      return {
        ...state,
        deleting: false,
        sponsors: state.sponsors.filter(c => c._id !== action.payload._id),
      };
    case 'DELETE_SPONSOR_FAILURE':
      return {
        ...state,
        deleting: false,
        error: action.payload,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/sponsor.js